var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgArrowLeft = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M13.066 3.764 5.58 11.25H21.5v1.5H5.582l.852.854 6.62 6.633L12 21.293 2.707 12l9.294-9.295z"
})));
export { SvgArrowLeft as ReactComponent };
export default __webpack_public_path__ + "e0d2cd4ceba32e9aa62b7a5a49ab6faa.svg";